module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lmJlX"))).then(() => parcelRequire('9Lwss'));